<template>
    <div class="py-5">
        <b-card style="max-width: 600px" class="mx-auto text-left px-3 py-3">
            <h5 class="pb-3">Register</h5>
            <b-form-group 	label="Email"
                            :state="errors.has('email')? false : null"
                            :invalid-feedback="errors.first('email')"
            >
                <b-form-input 	name="email"
                                v-model="email" 
                                v-validate="'required|email'"
                                :state="errors.has('email')? false : null"
                />
            </b-form-group>

            <b-form-group 	label="First Name"
                            :state="errors.has('firstName')? false : null"
                            :invalid-feedback="errors.first('firstName')"
            >
                <b-form-input 	name="firstName"
                                v-model="firstName" 
                                v-validate="'required'"
                                :state="errors.has('firstName')? false : null"
                />
            </b-form-group>

            <b-form-group 	label="Last Name"
                            :state="errors.has('lastName')? false : null"
                            :invalid-feedback="errors.first('lastName')"
            >
                <b-form-input 	name="lastName"
                                v-model="lastName" 
                                v-validate="'required'"
                                :state="errors.has('lastName')? false : null"
                />
            </b-form-group>

            <b-form-group 	label="Job">
                <b-form-input 	v-model="job" />
            </b-form-group>

            <b-form-group 	label="Department">
                <b-form-input 	v-model="department" />
            </b-form-group>

            <b-form-group 	label="Phone">
                <b-form-input 	v-model="phone" />
            </b-form-group>

            <b-form-group 	label="Password"
                            :state="errors.has('password')? false : null"
                            :invalid-feedback="errors.first('password')"
            >
                <b-form-input 	name="password"
                                type="password"
                                v-model="password" 
                                v-validate="'required|min:5'"
                                :state="errors.has('password')? false : null"
                />
            </b-form-group>


            <div class="text-right">
                <b-btn variant="primary" class="mr-2" @click="register">Register</b-btn>
                <b-btn variant="secondary" to="/login">Log In</b-btn>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            job: '',
            department: '',
            phone: ''
        }
    },

    methods: {
		async register() {
			if (!await this.$validator.validate()) {
				return;
			}

			this.$app.service('users').create({ 
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email,
                job: this.job,
                department: this.department,
                phone: this.phone,
				password: this.password
			})
				.then(this.login)
				.catch(error => alert(error));
		},

		login(response) {
			this.$app.authenticate({
				strategy: 'local',	
				email: this.email,
				password: this.password
			})
				.then(response => {
					this.$router.push({ name: 'Dashboard' });
				})
				.catch(error => alert(error));
		}
	}
}
</script>
